function acceptAllCookies(accept, accepted, consentAcceptAll) {
  if (consentAcceptAll) {
    consentAcceptAll.forEach(function (each) {
      each.addEventListener("click", () => {
        gtag("event", accept, {
          event_category: "Cookies",
          event_label: accepted,
          value: "{{ request.host | append: request.path }}",
        });
      });
    });
  }
}

function cookieConsent() {
  let consentAcceptAll = document.querySelectorAll(
    "#shopify-pc__banner__btn-accept"
  );

  if (consentAcceptAll) {
    acceptAllCookies("cookie-accept", "cookie-accepted", consentAcceptAll);
  }

  let consentRejectAll = document.querySelectorAll(
    "#shopify-pc__banner__btn-decline"
  );

  if (consentRejectAll) {
    acceptAllCookies("cookie-reject", "cookie-rejected", consentRejectAll);
  }

  let manageCookie = document.querySelector(
    "#shopify-pc__banner__btn-manage-prefs"
  );

  if (manageCookie) {
    manageCookie.addEventListener(
      "click",
      () => {
        let consentAcceptAllDialog = document.querySelectorAll(
          "#shopify-pc__prefs__header-accept, #shopify-pc__prefs__header-save"
        );

        if (consentAcceptAllDialog) {
          acceptAllCookies(
            "cookie-accept",
            "cookie-accepted",
            consentAcceptAllDialog
          );
        }

        let consentRejectAllDialog = document.querySelectorAll(
          "#shopify-pc__prefs__header-decline"
        );
        if (consentRejectAllDialog) {
          acceptAllCookies(
            "cookie-reject",
            "cookie-rejected",
            consentRejectAllDialog
          );
        }
      },
      { once: true }
    );
  }

  if (document.querySelector("#shopify-pc__banner")) {
    clearInterval(cookieInterval);
  }
}

let cookieInterval = setInterval(cookieConsent, 100);
